import DisplayPreferences from "@/domain/entities/user/DisplayPreferences";
import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import { DisplayPreferences as DisplayPreferencesMailvista } from "@cs_teamwaydev/mailvista-sdk_react";
import {
    dashboardWidgetSettingsToDomainMapper,
    dashboardWidgetSettingsToSDKMapper,
} from "./dashboardWidgetSettingsMapper";

const displayPreferencesToDomainMapper = (
    displayPreferences: DisplayPreferencesMailvista,
): DisplayPreferences =>
    new DisplayPreferences({
        emailDisplayMode:
            displayPreferences.emailDisplayMode as EmailDisplayMode,
        dashboardWidgets: dashboardWidgetSettingsToDomainMapper(
            displayPreferences.dashboardWidgets,
        ),
    });

const displayPreferencesToSDKMapper = (
    displayPreferences: DisplayPreferences,
): DisplayPreferencesMailvista => ({
    emailDisplayMode: displayPreferences.emailDisplayMode as EmailDisplayMode,
    dashboardWidgets: dashboardWidgetSettingsToSDKMapper(
        displayPreferences.dashboardWidgets,
    ),
});

export { displayPreferencesToDomainMapper, displayPreferencesToSDKMapper };
